export const PASSWORD_CHAR_LENGHT = 12;
export const PASSWORD_VALIDATION =
	/^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[~!@#%&_\+\{\}":\?\>\<\[\];'\/\.\\\-*]).{12,}$/i;
export const EMAIL_VALIDATION = /^\w+([\.\+\-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/i;
export const INPUT_CHAT_VALIDATION = /^(?!.*(<|>|&)).*$/;
export const URL_VALIDATION =
	/^(https?:\/\/)(www\.)?([a-zA-Z\d-]+(\.[a-zA-Z\d-]+)+)(:\d+)?(\/[-a-zA-Z\d%_.~+]*)*(\?[;&a-zA-Z\d%_.~+=-]*)?(\#[-a-zA-Z\d_]*)?$/;
